import React from "react";
import { Card } from "../../components/blog/Card";
import { Category } from "../../components/category/Category";

const Pages = () => {
  return (
    <div>
      <Category />
      <Card />
    </div>
  );
};

export default Pages;
